export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-2.17b22578.jpg";